module.exports = __webpack_public_path__ + "static/germiston-507b08dbe3fb77203fa743c9cff2dfe0.jpeg";